module.exports = __webpack_public_path__ + "d27c781c1bb4eb78e9ec3dbccbfabf61.png";